module.exports = __webpack_public_path__ + "media/SwordSwing.f05f761d.mp3";